import { SocialAccountStatus } from '@anytag/graphql';
import { signedUpImage } from '@anytag/shared-assets';
import { Anchor, AnchorProps } from './Anchor';

export interface AnchorWithStatusProps extends AnchorProps {
  status: SocialAccountStatus;
}

export const AnchorWithStatus = ({ status, ...anchorProps }: AnchorWithStatusProps) => (
  <>
    <Anchor {...anchorProps} />
    {status === SocialAccountStatus.SIGNED_UP && (
      <img css={{ width: '12px', height: '12px', alignSelf: 'baseline' }} src={signedUpImage} alt="profile status" />
    )}
  </>
);
